import usaF from 'assets/images/usa.png'
import aoef from 'assets/images/uae.png'
import ukf from 'assets/images/gb.png'

export const countries = {
  us: {
    label: 'United States',
    key: 'us',
    flagUrl: usaF,
    telFormat: '+1##########',
    mask: '+1',
  },
  uae: {
    label: 'United Arab Emirates',
    key: 'uae',
    flagUrl: aoef,
    telFormat: '+971#########',
    mask: '+971',
  },
  uk: {
    label: 'United Kingdom',
    key: 'uk',
    flagUrl: ukf,
    telFormat: '+44#########',
    mask: '+44',
  },
}
